import { SxProps, Theme } from "@mui/material";
import { CSSProperties } from "react";

export const root: (incomingStyle?: CSSProperties) => SxProps<Theme> =
  (incomingStyle) => (theme) => ({
    marginTop: `-${theme.spacing(1)}`,
    ...incomingStyle,
  });
